/**
Crank should be a canvas object you click on with the mouse and spin.
The idea is something active you have to do to reload, we want to make everything active.

note: AI written slop
*/
const wrap = document.getElementById('crank') as HTMLDivElement;
const group = document.getElementById('crankGroup') as HTMLOptGroupElement;
const handle = document.getElementById('handle') as HTMLOrSVGElement;
const progress = document.getElementById('progress') as HTMLOrSVGElement;
const cx = 110, cy = 110;
const releaseR = 50;
let angle = 0;
let dragging = false;
let lastAngle = 0;
const cranksRequired = 2;

export let totalRad = 0;

export let reloaded = true;

export function unloadShell(){
    reloaded = false;
    totalRad = 0;
    angle = 10;
    render()
}

setInterval(() => {
    if(totalRad > 0 && !dragging){
        angle -= 0.005 * totalRad / cranksRequired;
        totalRad -= 0.005 * totalRad / cranksRequired;
        render();
    }
    if(totalRad >= 360 * cranksRequired){
        totalRad = 0;
        angle = 0;
        reloaded = true;
        dragging = false;
        render();
    }
}, 16);

function svgPoint(evt:MouseEvent) {
  const rect = wrap.getBoundingClientRect();
  const scale = 220 / rect.width;
  const x = (evt.clientX - rect.left) * scale;
  const y = (evt.clientY - rect.top) * scale;
  return { x, y };
}

function angleAt(evt:MouseEvent) {
  const p = svgPoint(evt);
  return Math.atan2(p.y - cy, p.x - cx) * 180 / Math.PI;
}

function handleCenter() {
  const rotRad = angle * Math.PI / 180;
  const localX = 0, localY = -75;
  const hx = cx + localX * Math.cos(rotRad) - localY * Math.sin(rotRad);
  const hy = cy + localX * Math.sin(rotRad) + localY * Math.cos(rotRad);
  return { x: hx, y: hy };
}

function render() {
  group.setAttribute('transform', `rotate(${angle} ${cx} ${cy})`);
  if(reloaded){
    progress.setAttribute("width", "220");
  }else{
    progress.setAttribute("width", 220 * (totalRad / (360 * cranksRequired)));
  }
}

function startDrag(evt:MouseEvent) {
  if(reloaded){return;}
  dragging = true;
  handle.style.cursor = 'grabbing';
  lastAngle = angleAt(evt);
  evt.preventDefault();
}

function moveDrag(evt:MouseEvent) {
  if (!dragging) return;
  const p = svgPoint(evt);
  const center = handleCenter();
  const dist = Math.hypot(p.x - center.x, p.y - center.y);
  if (dist > releaseR) {
    endDrag();
    return;
  }
  const a = angleAt(evt);
  let delta = a - lastAngle;
  if (delta > 180) delta -= 360;
  if (delta < -180) delta += 360;
  angle += delta;
  totalRad += delta;
  lastAngle = a;
  render();
}


function endDrag() {
  dragging = false;
  handle.style.cursor = 'grab';
}

handle.addEventListener('mousedown', startDrag);
window.addEventListener('mousemove', moveDrag);
window.addEventListener('mouseup', endDrag);
handle.addEventListener('touchstart', (e) => startDrag(e.touches[0]), {passive:false});
window.addEventListener('touchmove', (e) => { if(dragging){ moveDrag(e.touches[0]); e.preventDefault(); } }, {passive:false});
window.addEventListener('touchend', endDrag);

render();